module.exports = __webpack_public_path__ + "static/media/Pic-0488.ceff1833.jpg";